/** Decode a JWT payload without verifying the signature (client-side only). */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(normalized);
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Return JWT `exp` as epoch milliseconds, or null if missing/invalid. */
export function getTokenExpiryMs(token: string): number | null {
  const claims = decodeJwtPayload(token);
  if (!claims || typeof claims.exp !== 'number') {
    return null;
  }
  return claims.exp * 1000;
}

export function isTokenExpired(token: string, skewMs = 30_000): boolean {
  const expiry = getTokenExpiryMs(token);
  if (expiry == null) {
    return true;
  }
  return Date.now() >= expiry - skewMs;
}
